export default "__VITE_ASSET__H87v6Zvx__"